module.exports = __webpack_public_path__ + "img/collection-diamondJewelrySets.2c8891b.webp";